const errorMessage = (errorcode, error) => {

    const message = {
        ogImageError: "Por favor, carregue a imagem OG",
        notUpdated: "Não atualizado",
        notLoggedIn: "Não logado",
        optionUnavailable: "Esta opção já não está disponível.",
        unknownOption: "A opção selecionada não existe.",
        duplicateOption: "Uma opção foi selecionada mais de uma vez.",
        invalidBillingMode: "Modo de faturação da opção inválido.",
        deliveryLocationRequired: "Introduza um local de entrega (mínimo de 5 caracteres).",
        deliveryLocationTooLong: "O local de entrega é demasiado longo (máximo de 255 caracteres).",
        invalidDays: "Duração do aluguer inválida.",
        bookingTotalMismatch: "O valor da reserva foi alterado. Verifique o novo total e tente novamente.",
        optionDisabledByAdmin: "Este serviço foi desativado pela GOZY.",
        invalidOptionSlot: "Opção inválida.",
        maxOptionsReached: "Atingiu o número máximo de opções personalizadas.",
        invalidOptionPrice: "Introduza um preço válido superior a 0 para uma opção ativa.",
        invalidOptionLabel: "O nome da opção deve ter entre 3 e 40 caracteres.",
        reservedOptionLabel: "Este nome está reservado a um serviço predefinido.",
        optionLabelTaken: "Já tem uma opção com este nome.",
        invalidOptionDescription: "A descrição não deve exceder 140 caracteres.",
        optionNotFound: "Opção não encontrada.",
        notListingOwner: "Só pode gerir as opções dos seus próprios anúncios.",
        listingNotAvailable: "A listagem não está disponível",
        notAvailable: "não disponível",
        updateStatusError: "Ops! Não foi possível atualizar o status. Tente novamente.",
        loginError: "Ops! Faça login e continue.",
        createReservationError: "Falha ao criar uma reserva.",
        createPayoutError: "Falha ao criar um pagamento.",
        deleteRecordError: "Erro ao excluir um registro.",
        commonError: error ? error : "Ops! Algo deu errado. Tente novamente.",
        adminRoleError: "Desculpe, não foi possível encontrar esta função de administrador.",
        deleteAdminRoleError: "Ops! Não foi possível excluir a função de administrador porque algum usuário administrador está usando esta função.",
        invalidAdminRole: "Ops, parece que a função escolhida não é válida. Tente selecionar uma função válida diferente.",
        checkEmail: "Ops! Este endereço de e-mail já existe.",
        noDocumentsFound: "Nenhum documento encontrado. Tente novamente.",
        userLoginAccount: "Ops! Entre com sua conta e tente novamente.",
        updateReviewError: "Ocorreu um erro! Não foi possível atualizar a avaliação. Tente novamente mais tarde.",
        somethingWrong: "Algo deu errado. Tente novamente.",
        invalidRequest: "Solicitação inválida",
        chooseOption: "Pelo menos uma opção deve estar ativa.",
        noRecord: "Algo deu errado! Nenhum registro encontrado. Tente novamente.",
        userLogin: "Ocorreu um erro! Faça login e tente novamente.",
        findActiveReservation: "Ops! Não foi possível excluir este usuário. Parece que o usuário tem reservas ativas/próximas e precisa cancelar ou concluir as reservas para excluí-las.",
        createThreadItemFailed: "Falha ao criar itens de thread.",
        createThreadFailed: "Falha ao criar um tópico.",
        checkUserExist: "Ops! O usuário é diferente.",
        adminLogin: "Efetue login como usuário administrador e tente novamente.",
        noRecordFound: "Nenhum registro encontrado.",
        fetchRecordsError: "Algo deu errado ao buscar registros. Tente novamente.",
        userLoggedIn: "Você não está conectado. Efetue login e tente novamente.",
        checkListSettings: "Ops! Não foi possível encontrar as configurações da lista. Tente novamente.",
        userNotLoggedIn: "Usuário não logado",
        userLoginError: "Ops! Faça login e continue.",
        wrongConfirmPassword: "Confirmar Senha Errada",
        wrongPassword: "Senha Errada",
        updateFailed: "atualização falhou",
        userLoginExist: "Por favor, faça login com sua conta",
        invalidError: "Algo deu errado",
        checkUserLogin: "Por favor faça login",
        userBan: "usuário banido",
        adminLoginError: "Por favor, faça login como administrador e tente novamente",
        unableToProceed: "Ops! Não foi possível prosseguir com a ação solicitada. Tente novamente.",
        errorLogin: "Por favor faça login e continue",
        userNotExist: "Nenhum usuário existe",
        userExist: "UsuárioExist",
        userUnBan: "usuário não banido",
        userNotDeleted: "usuárioNãoDeletado",
        userDeleted: "usuário excluído",
        adminLoggedIn: "adminLogado",
        login: "logado",
        unknownError: "Desculpe, algo deu errado. Tente novamente.",
        success: "Sucesso",
        error: "Erro!",
        warning: "Aviso!",
        forgotPassword: "Não há nenhuma conta associada ao endereço de e-mail fornecido.",
        tryAgain: "Algo deu errado, tente novamente mais tarde",
        resetPasswordLink: "Enviamos um link para redefinir sua senha para o seu e-mail. Verifique sua caixa de entrada!",
        contactHost: "Sua solicitação foi enviada ao proprietário.",
        updatePassword: "Você atualizou sua senha com sucesso. Agora você pode tentar fazer login!",
        confirmPasswordError: "A senha confirmada não corresponde à nova senha.",
        passwordUpdateSuccess: "A senha foi atualizada com sucesso!",
        incorrectPassword: "A senha atual está incorreta. Tente novamente.",
        userNotLogin: "Você não está logado",
        currentPassword: "A senha atual está incorreta. Tente novamente.",
        changePasswordError: "Desculpe, algo deu errado! Recarregue esta página!",
        payoutStatusSuccess: "O status foi atualizado.",
        payoutStatusFailed: "Falha ao atualizar o status.",
        invalidAddress: "Seu endereço parece ser inválido, verifique e edite seu endereço!",
        failedPayout: "O pagamento ao proprietário falhou. Tente novamente com uma moeda diferente.",
        successPayout: "O pagamento foi transferido com sucesso para o proprietário.",
        paymentToOwnerFailed: "O pagamento ao proprietário falhou. Tente novamente com uma moeda diferente.",
        serviceFeeUpdate: "As taxas de serviço foram atualizadas com sucesso!",
        serviceFeeUpdateFailed: "A atualização das taxas de serviço falhou!",
        deleteBlogDetails: "Os detalhes do blog foram excluídos.",
        blogDeletionFailed: "Falha na exclusão do blog!",
        updateBlogStatus: "O status foi alterado com sucesso!",
        updateBlogStatusFailed: "Falha ao alterar o status",
        updateBlogSuccess: "As alterações do blog foram atualizadas com sucesso!",
        deleteListing: "A configuração foi excluída.",
        unableToDisableListSetting: "Não é possível excluir a configuração da lista. Deve haver pelo menos uma configuração de lista disponível para os carros.",
        unableToDeleteListSetting: "Não é possível excluir as configurações da lista. A configuração da lista é usada na propriedade. Remova a configuração da lista do carro e tente novamente.",
        listSettingModelUsed: "Não é possível excluir a \"Marca\". A \"Marca\" serve para criar um modelo. Remova o modelo dos carros e tente novamente.",
        updateListSettings: "As configurações da lista foram atualizadas com sucesso!",
        deletePopularLocation: "Localização popular foi excluída com sucesso!",
        deletePopularLocationFailed: "Falha na exclusão de Locais Populares!",
        locationStatusChanged: "O status da localização foi alterado com sucesso!",
        locationStatusFailed: "Falha ao alterar o status da localização.",
        updateFindYourBlock: "As alterações foram atualizadas.",
        updateBannerSettings: "As alterações foram atualizadas com sucesso!",
        updateBannerSettingsFailed: "Falha ao atualizar as configurações do banner",
        updateBanStatus: "O status de banimento foi atualizado com sucesso.",
        selectBanOrUnBan: "Você deve selecionar a opção de banir ou desbanir.",
        updateBanStatusFailed: "Falha ao atualizar o status do banimento.",
        paymentGatewayUpdated: "Gateway de pagamento atualizado.",
        lastCheckoutRequired: "Pelo menos um gateway ativo deve ter o Checkout habilitado.",
        paymentGatewayStatus: "Pelo menos um gateway de pagamento deve estar ativo.",
        paymentGatewayStatusFailed: "Falha ao atualizar o status.",
        updateStaticPageSuccess: "As alterações foram atualizadas.",
        updateStaticPageFailed: "A atualização falhou",
        updateStaticPageStatus: "Falha ao alterar o status",
        deleteUser: "Usuário foi excluído com sucesso!",
        deleteUserFailed: "Falha na exclusão do usuário!",
        updateWhyHost: "Por que as alterações na página \"Tornar-se proprietário\" foram atualizadas com sucesso!",
        noDataFound: "Nenhum dado encontrado no arquivo",
        importCsvFileError: "Ops, algo deu errado. Tente novamente mais tarde.",
        invalidSpecialPrice: "Preço especial é inválido.",
        invalidImageFile: "Você está tentando enviar um arquivo de imagem inválido. Envie um arquivo de imagem nos formatos PNG, JPG e JPEG.",
        deleteReview: "A avaliação foi excluída com sucesso!",
        deleteReviewFailed: "Falha na exclusão da avaliação!",
        deleteAdminRole: "A função de administrador foi excluída com sucesso!",
        deleteAdminUser: "O usuário administrador foi excluído com sucesso!",
        updateConfigSettings: "As configurações foram atualizadas com sucesso!",
        setDefaultBaseCurrency: "Moeda base padrão modificada com sucesso",
        setDefaultBaseCurrencyFailed: "Falha ao definir a moeda base.",
        disableBaseCurrencyError: "Desculpe, não é possível desativar a moeda base atual. Defina uma moeda base diferente e, em seguida, desative esta.",
        currencyStatusSuccess: "O status da moeda foi alterado com sucesso!",
        currencyStatusFailed: "Falha ao alterar o status da moeda.",
        managePaymentCurrencySuccess: "Alterações na moeda de pagamento foram atualizadas com sucesso!",
        managePaymentCurrencyFailed: "Falha ao alterar o status da moeda de pagamento.",
        removeRecommend: "A lista foi removida com sucesso da lista de recomendados",
        addRecommendList: "A lista foi adicionada com sucesso à lista de recomendados.",
        removeListingSuccess: "A lista foi removida com sucesso",
        unpublishListing: "Você não pode cancelar a publicação, pois tem reservas ou consultas futuras para este anúncio.",
        userReviewUpdated: "A avaliação foi atualizada com sucesso.",
        checkTermsAndPolicy: "Verifique os termos e a política de privacidade para prosseguir.",
        updatePopularLocation: "As alterações de localização foram atualizadas com sucesso!",
        updatePopularLocationFailed: "Falha na atualização do local",
        addBlog: "O blog foi adicionado com sucesso!",
        addBlogFailed: "O URL da página já existe!",
        failedToCreateBlog: "Falha ao criar",
        failedToUpdateBlog: "Falha na atualização do blog",
        addedLocation: "Localização adicionada com sucesso!",
        addedLocationFailed: "Falha ao criar",
        updateProfile: "Suas alterações foram atualizadas!",
        bookingFailed: "Essas datas não estão disponíveis!",
        alreadyPerformedAction: "Você já executou esta ação!",
        adminAccessDetails: "Os detalhes de acesso do administrador foram alterados com sucesso!",
        listingUnPublish: "O anúncio foi despublicado ou excluído pelo proprietário/administrador. Tente outro.",
        removePhotosListing: "Você não pode remover fotos, pois este anúncio tem reservas ou consultas futuras!",
        confirmationEmail: "Enviamos um link de confirmação para seu e-mail.",
        sentEmailFailed: "Desculpe, algo deu errado. Tente novamente!",
        reservationCancelled: "Sua reserva foi cancelada.",
        tripCancelled: "Sua viagem foi cancelada.",
        cancelReservationSuccess: "Sua reserva já foi atualizada!",
        importCalendar: "O processo de sincronização do seu calendário foi iniciado!",
        calendarAlreadyExists: "Seu calendário já foi importado!",
        invalidCalendar: "O URL é inválido e a importação do calendário falhou.",
        maximumUploadSize: "Tamanho máximo de upload excedido! Tente com o menor tamanho de imagem",
        calendarRemoved: "Seu calendário foi removido!",
        deleteCalendarFailed: "Seu calendário não foi excluído com sucesso. Tente novamente.",
        payoutToHost: "O valor reivindicado foi transferido com sucesso para o anfitrião!",
        paymentToHostFailed: "O pagamento ao proprietário falhou, tente novamente com uma moeda diferente",
        paymentToHost: "O pagamento ao proprietário falhou, tente novamente",
        importDuplicateItems: "Parece que há alguns itens duplicados no arquivo de importação, mas as novas entradas foram importadas com sucesso.",
        formError: "Desculpe, algo deu errado. Tente novamente!",
        updateBlockedDates: "Ops! Você não tem permissão para atualizar essas datas, pois algumas delas já possuem reservas ativas.",
        removeBlockedDates: "Essas datas não estão disponíveis!",
        uploadDocument: "O documento foi carregado com sucesso!",
        uploadDocumentError: "Algo deu errado!",
        requiredError: "Parece que você deixou alguns campos obrigatórios em branco. Por favor, preencha-os.",
        updateListingError: "Os dados que você selecionou não estão disponíveis. Tente novamente.",
        importSuccess: "Sucesso! Seu arquivo foi importado com sucesso.",
        addContent: "Por favor adicione conteúdo",
        addLocationImage: "Por favor, adicione a imagem do local",
        addMetaTitle: "Por favor, adicione o título Meta",
        addMetaDescription: "Por favor, adicione a meta descrição",
        uploadPngImage: "Você está tentando enviar um arquivo de imagem inválido. Envie um arquivo de imagem no formato PNG.",
        csvFormat: "Certifique-se de que o formato CSV deve ter a seção Make",
        csvFormatError: "Certifique-se de que o formato CSV tenha Marca e Modelo como formato.",
        uploadImage: "Por favor, carregue a imagem!",
        isAdmin: "Você está logado como administrador, não pode executar esta ação!",
        checkUpcomingBooking: "Você não pode excluir este anúncio, pois ele tem reservas ou consultas futuras.",
        checkAge: "Desculpe, você deve ter 18 anos",
        checkDay: "O campo de data de nascimento está faltando",
        checkMonth: "O campo do mês de nascimento está faltando",
        checkYear: "O campo do ano de nascimento está faltando",
        invalidDateOfBirth: "Data de nascimento inválida, preencha os dados válidos",
        emailAlreadyExist: "O e-mail já existe, tente outro endereço de e-mail!",
        loginUser: "Você não está logado, faça login e tente novamente!",
        reloadPage: "Desculpe, algo deu errado! Recarregue esta página e tente novamente!",
        uploadCarPhoto: "A foto do seu carro foi carregada com sucesso!",
        statusUpdate: "O status foi atualizado",
        claimAmount: "O valor reivindicado foi reembolsado com sucesso!",
        emailSent: "Seu e-mail foi enviado",
        documentRemoved: "O documento foi removido com sucesso!",
        claimAmountUpdate: "O valor da reivindicação foi atualizado com sucesso!",
        imageRemoved: "A imagem foi removida com sucesso",
        phoneNumberVerify: "O número de telefone foi verificado com sucesso.",
        linkCopied: "Link copiado com sucesso",
        updateWhyHostPage: "Por que as configurações de se tornar proprietário foram atualizadas com sucesso!",
        updateWhyHostPageFailed: "Falha ao atualizar as configurações de \"por que se tornar proprietário",
        alreadyReviewed: "Você já revisou essas reservas!",
        datesNotAvailable: "Essas datas não estão disponíveis.",
        inCompleteZipCode: "Seu código postal está incompleto.",
        adminClaimModalError: "Algo deu errado",
        footerSettingsUpdate: "As alterações nas configurações do rodapé foram atualizadas com sucesso!",
        footerSettingsUpdateFailed: "Falha ao atualizar as configurações do rodapé",
        blockSettingsFailed: "Falha ao atualizar as configurações do bloco estático",
        blockSettingsUpdate: "As alterações nas configurações do bloco estático foram atualizadas com sucesso!",
        updateAdminReview: "Os detalhes da revisão do administrador foram atualizados com sucesso!",
        submitAdminReview: "Os detalhes da revisão do administrador foram enviados com sucesso!",
        updateUserReview: "Os detalhes da avaliação do usuário foram atualizados com sucesso!",
        listIdNotAvailable: "O ID da lista não está disponível!",
        adminReviewFailed: "Suas alterações na revisão do administrador falharam!",
        alreadyEmailExist: "Ops! Este endereço de e-mail já existe.",
        adminDetailsFailed: "Suas alterações nos detalhes de acesso do administrador falharam!",
        settingsUpdate: "As alterações nas configurações foram atualizadas com sucesso!",
        settingsUpdateFailed: "Falha ao atualizar as configurações",
        searchSettingsUpdate: "As alterações nas configurações de pesquisa foram atualizadas com sucesso!",
        searchSettingsUpdateFailed: "Falha ao atualizar as configurações de pesquisa",
        paymentSettingsUpdate: "As alterações nas configurações de pagamento foram atualizadas com sucesso!",
        paymentSettingsUpdateFailed: "Falha ao atualizar as configurações de pagamento",
        checkActiveListing: "Não é possível desabilitar a configuração de lista. Pelo menos uma configuração de lista deve estar ativa.",
        removeListSettings: "Não foi possível desativar a configuração de lista. A configuração de lista está sendo usada nos carros. Remova a configuração de lista dos carros e tente novamente.",
        removeModel: "Você não pode realizar esta ação, pois a respectiva marca está sendo usada no modelo. Remova-o da página do modelo e prossiga.",
        listSettingsSuccess: "As configurações da lista foram criadas com sucesso!",
        listSettingsFailed: "O nome do artigo adicionado já existe",
        paymentTransferToReenter: "O pagamento foi transferido com sucesso para o locatário",
        paymentTransferFailed: "O pagamento ao locatário falhou, tente novamente com uma moeda diferente",
        duplicateFiles: "Parece que seu arquivo de importação contém itens duplicados. Verifique o arquivo e importe os novos itens.",
        limitExceed: "Limite excedido! Importe os dados para até 3.000 registros.",
        invalidCurrency: "A moeda escolhida não é aceita pelo PayPal para pagamento. Altere a moeda e tente efetuar o pagamento novamente.",
        checkPaymentState: "Para esta reserva, o pagamento já foi concluído",
        checkMakeDetails: "Nenhum detalhe de marca encontrado para o modelo",
        updateIOSSettings: "As configurações de layout foram atualizadas com sucesso!",
        adminUserLogged: "Parece que você já fez login como administrador. Saia do painel de administração do site e tente novamente.",
        isPublished: "Ops! Você não pode recomendar a lista não publicada",
        securityDepositChange: "O depósito de segurança foi atualizado! Entre em contato com o administrador.",
        networkFailed: "Você está offline. Tente novamente mais tarde.",
        offlineError: "Você está offline. Tente novamente mais tarde.",
        minDayMaxDay: "O mínimo de dias não pode ser maior que o máximo de dias",
        isAgreePhoneNumberError: "Marque a caixa de seleção de verificação por SMS e salve seus dados.",
        updateEditProfile: "As alterações foram atualizadas com sucesso",
        deleteUserAccount: "Sua conta foi excluída com sucesso",
        deleteUserAccountFailed: "Você não pode excluir sua conta porque atualmente você tem reservas ativas",
        smtpActiveStatus: "Status atualizado com sucesso!",
        deleteSmtpData: "O registro SMTP foi excluído com sucesso.",
        deleteSmtpDataError: "Você não pode excluir credenciais SMTP ativas",
        payoutCurrencySuccess: "A moeda de pagamento foi atualizada com sucesso",
        payoutCurrencyFailed: "Você não tem permissão para atualizar a moeda de pagamento preferida",
        cantDisablePayoutCurrency: "Você não pode desativar esta moeda, pois ela é a moeda de pagamento preferencial. Defina uma moeda diferente como moeda de pagamento preferencial antes de desativar esta.",
        hostServiceFeeError: "Ops! Você não pode reservar este carro devido a um erro de preço. Entre em contato com o suporte para obter mais assistência.",
        contactHostError: "Você já solicitou nesta data",
        addSmtpData: `As configurações de SMTP foram adicionadas com sucesso.`,
        documentManagementError: `Algo deu errado! ${error}`,
        addWishListGroupForm: error,
        stripePaymentGateway: `Stripe foi ${error} com sucesso`,
        paypalPaymentGateway: `O Paypal foi ${error} efetuado com sucesso`,
        addUpdateAdminRole: `A função de administrador foi ${error ? 'atualizada' : 'adicionada'} com sucesso!`,
        adminRoleError: `Ops, algo deu errado"  ${error}`,
        addUpdateAdminUser: `O usuário administrador foi ${error ? 'atualizada' : 'adicionada'} com sucesso!`,
        adminUserError: `Ops, algo deu errado" ${error} `,
        catchError: `Ops! Algo deu errado, ${error}`,
        listingFailed: `${error} è fallito!`,
        deleteUserDetails: error,
        failedError: error,
        invalidError: error,
        commonSuccess: error,
        checkStatus: error,
        accountDeleteError: 'Sua conta foi excluída com sucesso. Entre em contato com o suporte para obter assistência.',
        accountBanError: "Sua conta foi banida pelo administrador. Entre em contato com o suporte para obter assistência.",
        mailTypeError: "Endereço de recebimento ou tipo de modelo é necessário",
        filenameError: "Nome de arquivo não existe",
        fileRemoved: 'Os arquivos foram removidos com sucesso',
        fileNotRemoved: 'Arquivos não excluídos',
        otpError: "Tente novamente após 2 minutos para receber um novo OTP",
        cardError: 'Spiacenti, si è verificato un problema con la tua carta. Riprova.',
        mobileLanguageSuccess: `O idioma para dispositivos móveis foi atualizado com sucesso!`,
        webLanguageSuccess: `O idioma da web foi atualizado com sucesso!`,
        mobileLanguageError: `Ops! Algo deu errado. A atualização do idioma para dispositivos móveis falhou!`,
        mobileLanguageDuplicateError: `Ops! Algo deu errado. A atualização do idioma ${error == 'web' ? 'web' : 'móvel'} falhou. Foram encontrados registros duplicados`,
        mobileLanguageEmptyError: `Ops! Algo deu errado. A atualização do idioma ${error == 'web' ? 'web' : 'móvel'} falhou. Foram encontrados registros vazios`,
        mobileLanguageRegexError: `Ops! Algo deu errado. A atualização do idioma ${error == 'web' ? 'web' : 'móvel'} falhou. Os registros não correspondem a caracteres alfabéticos`,
        documentChangeWarning: `Os documentos foram aprovados e não podem mais ser modificados.`,
        settingUpdateSuccess: `As alterações nas configurações do site foram aplicadas com sucesso`,
        demoWarning: `Desculpe, você não tem permissão para alterar ou remover as informações da demonstração.`,
        disableDemo: `Esta ação está desabilitada no site de demonstração.`,
        reportTypeDeleteError: 'Você não pode excluir este tipo de relatório. Pelo menos um tipo de relatório deve permanecer na seção Tipo de Relatório.',
        invalidReportId: 'O ID do relatório não está disponível',
        reportTypeAddSuccess: 'O tipo de relatório foi adicionado com sucesso',
        reportTypeUpdateSuccess: 'O tipo de relatório foi atualizado com sucesso',
        reportTypeDeleteSuccess: 'O tipo de relatório foi excluído com sucesso',
        notReportContent: 'Selecione pelo menos um tipo de relatório antes de enviar.',
        invalidEmail: 'O endereço de e-mail informado é inválido. Verifique e tente novamente.',
        updateSmtpData: `As configurações de SMTP foram atualizadas com sucesso.`,
        listPublish: `Seus anúncios foram publicados com sucesso!`,
        listUnPublish: `Suas listas foram despublicadas com sucesso!`,
        promoCodeUpdatedSuccess: 'Os detalhes do código promocional foram atualizados com sucesso',
        promoCodeUpdated: 'Os detalhes do código do cupom foram atualizados com sucesso',
        promoDeletedSuccess: 'O código do cupom foi excluído com sucesso',
        promoCodeAddedSuccess: 'O código do cupom foi adicionado com sucesso',
        promoCodeExist: 'Ops! Parece que este código promocional já está em uso. Tente novamente com um nome de código promocional diferente.',
        usedPromo: 'Parece que o código promocional que você inseriu já foi usado em outra reserva. Por favor, use um código promocional diferente.',
        invalidPromo: 'Insira um código promocional válido para receber um desconto.',
        updateCurrencyError: 'Esta moeda não pode ser removida ou desativada porque pelo menos uma moeda deve permanecer ativa.',
        servicePlanAdd: "O plano de serviço foi adicionado com sucesso",
        servicePlanUpdate: "O plano de serviço foi atualizado com sucesso",
        deleteServicePlansSuccess: "O plano de serviço foi excluído com sucesso",
        servicePlanImageError: "Você não pode salvar o plano de serviço sem adicionar a imagem. Faça upload de uma imagem e prossiga.",
        servicePlanStatusSuccess: "O status do plano de serviço foi atualizado com sucesso",
        mobileSetDefaultError: 'Você não pode definir um idioma inativo como padrão.',
        mobileSetInActiveError: 'O idioma padrão não pode ser desativado enquanto estiver definido como padrão.',
        existAdminUser: `Ops! este endereço de e-mail já existe.`,
        ContactHostSameTimeErrorForAI: `Erro. ​​Você precisa escolher um horário de término diferente para prosseguir.`,
        paymentActiveError: 'Não é possível desativar essa opção no momento, pois alguns usuários estão utilizando ativamente esse recurso.',
        duplicateOrder: `Números de pedido duplicados não são permitidos. Por favor, tente novamente com um número de pedido diferente.`,
        keyValueRequiredError: "Tanto a chave quanto o valor são obrigatórios para todas as entradas.",
        invalidCsvFileType: "Por favor, escolha um arquivo CSV.",
        invalidCsvColumns: "A folha deve ter exatamente duas colunas: chave e valor.",
        emptyCsvSheet: "A folha está vazia ou não tem linhas chave-valor.",
        downloadLanguageCsv: "Baixar CSV",
        siteAdminPushNotification: "A notificação push foi enviada com sucesso",
        webLanguageError: `Ops! Algo deu errado. A atualização do idioma da web falhou!`,
        promoCodeCalculation: ' Promo codes cannot be applied when a weekly or monthly discount is already applied to this booking.',
        sendSMTPEmail: "Ops! Algo deu errado. Não foi possível enviar o e-mail.",
        duplicateRequestError: 'Detectada solicitação duplicada. Aguarde um momento antes de tentar novamente.',
        tooManyRequestsError: 'Muitas solicitações. Tente novamente em alguns minutos.',
        invalidRecaptchaError: 'reCAPTCHA ou solicitação inválida. Atualize e tente novamente.',
        chooseLanguageError: 'Por favor, selecione um idioma',
        alert: 'Alerta!',
        demoEmailWarning: 'Esta ação não é permitida no site de demonstração.',
        servicePlanDisabledWarning: "O recurso que você está experimentando não está disponível no momento. Entre em contato com o suporte para obter mais informações.",
        unEnableServicePlan: 'Ops! Não foi possível desativar o plano de serviço porque ele está em uso por um usuário.',
        inspectionWindowClosed: "O check-in ou o check-out não está disponível para esta reserva neste momento.",
        inspectionLocked: "Este registo foi validado por ambas as partes e já não pode ser alterado.",
        inspectionVersionConflict: "Existe uma versão mais recente. Consulte a última versão antes de continuar.",
        notReservationParty: "Apenas o proprietário ou o locatário desta reserva pode realizar esta ação.",
        mileageDecreasing: "A quilometragem de devolução não pode ser inferior à quilometragem de partida.",
        photoLimitReached: "O número máximo de fotos foi atingido.",
        invalidFuelLevel: "Selecione um nível de combustível válido.",
        decisionMotiveRequired: "É obrigatório indicar um motivo para esta decisão.",
        disputeAlreadyOpen: "Já existe uma disputa aberta para esta reserva.",
        inspectionDisabled: "A funcionalidade de check-in e check-out não está disponível neste momento.",
        inspectionActionNotAllowed: "Esta ação não é permitida no estado atual.",
        inspectionNotFound: "Nenhum check-in ou check-out encontrado para esta reserva.",
        inspectionAlreadyValidated: "Já validou esta versão.",
        invalidMileage: "Introduza uma quilometragem válida (número inteiro, 0 ou mais).",
        invalidGeneralState: "Selecione o estado geral do veículo.",
        commentTooLong: "O texto é demasiado longo (máximo de 500 caracteres).",
        invalidChecklist: "Preencha a lista de documentos e equipamentos.",
        damageAnswerRequired: "Indique se o veículo é devolvido sem danos.",
        damageDescriptionRequired: "Descreva o dano.",
        photoMinNotReached: "Adicione mais fotos antes de continuar.",
        invalidPhoto: "Uma ou mais fotos não são válidas para este registo.",
        noRecordsFound: "Desculpe, nenhum registro encontrado!",
        invalidReservationId: "Desculpe, você forneceu um ID de reserva inválido para este usuário.",
        invalidData: 'Ops! Algo deu errado. Forneça os dados.',
        loginAccount: "Por favor, faça login com sua conta e continue com sua reserva!",
        checkUserStatus: "Ops! Parece que sua conta está desativada no momento. Entre em contato com nosso suporte.",
        findAccount: "Ops! Não conseguimos encontrar sua conta. Entre em contato com o suporte para obter ajuda.",
        invalidRetainedAmount: "Introduza um valor retido válido (superior a 0 e inferior à caução).",
        invalidRequestedAmount: "Introduza um valor válido superior a 0.",
        attachmentLinked: "Este documento faz parte do processo de litígio e já não pode ser removido.",
        fileTooLarge: "O ficheiro é demasiado grande.",
        unsupportedFileType: "Este tipo de ficheiro não é aceite.",
        reportingInvalidPeriod: "Período inválido. Escolha hoje, 7 dias, 30 dias, este ano ou datas personalizadas.",
        reportingInvalidDate: "Introduza datas de início e de fim válidas (AAAA-MM-DD).",
        reportingEndBeforeStart: "A data de fim não pode ser anterior à data de início.",
        reportingPeriodTooLong: "O período não pode exceder 366 dias.",
        reportingInvalidGranularity: "Granularidade do gráfico inválida. Escolha dia, semana, mês ou ano.",
        reportingInvalidTab: "Separador de receitas inválido. Escolha todos, a receber, pagamento pendente ou pagos.",
        reportingListingNotFound: "Este veículo não foi encontrado entre os seus anúncios.",
        reportingCurrencyRateMissing: "Uma taxa de câmbio necessária para este relatório não está disponível. Contacte o suporte.",
        reportingInvalidCurrency: "Moeda de apresentação inválida.",
        reportingCsvStartDate: "Data de início",
        reportingCsvReservation: "Reserva",
        reportingCsvVehicle: "Veículo",
        reportingCsvTypes: "Tipos",
        reportingCsvGross: "Montante bruto",
        reportingCsvNet: "Receita líquida",
        reportingCsvStatus: "Estado",
        reportingCsvPaymentMethod: "Método de pagamento",
        reportingCsvReference: "Referência",
        reportingCsvTypeRental: "Aluguer",
        reportingCsvTypeOptions: "Opções",
        reportingCsvTypeDelivery: "Entrega",
        reportingCsvStatusUpcoming: "A receber",
        reportingCsvStatusPending: "Pagamento pendente",
        reportingCsvStatusPaid: "Pago",
        reportingCsvStatusCancelled: "Cancelada",
        reportingCsvTruncated: `Exportação limitada às primeiras ${error} linhas. Reduza o período ou os filtros para exportar o resto.`,
    }
    return message[errorcode];
}
export default errorMessage;